import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 获取用户基本信息
  userinfo(params) {
    return Axios({
      url: '/system/user/getInfo',
      method: 'get',
      params
    })
  },
  // 工地列表
  projectlist() {
    return Axios({
      url:'/system/userProject/getProjectList',
      method: 'get'
    })
  },
  // 出勤总天数
  checkinAllCount(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/worker/checkin/allCount',
      method: 'get',
      params
    })
  },
  // 已完成课程数
  finishLearnClassNum(params) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/finishLearnNum',
      method: 'get',
      params
    })
  },
  // 课程积分
  classPoint() {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/point',
      method: 'get'
    })
  },
  // 未学习课程数
  noLearnClassNum(params) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/class/learn/noLearnNum',
      method: 'get',
      params
    })
  },
  // 已参加考试次数
  examHistoryCount(params) {
    return Axios({
      url: requestPrefix.trainUrl + '/mobile/exam/history/count',
      method: 'get',
      params
    })
  },
  // 总平均工时
  avgHour(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/worker/checkin/avgHour',
      method: 'get',
      params
    })
  },
  // 某月的总考勤次数统计
  checkinDays(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/worker/checkin/month/count',
      method: 'get',
      params
    })
  },
  // 某月总工时
  checkinHour(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/worker/checkin/month/hour',
      method: 'get',
      params
    })
  },
  // 某月在某个工地的考勤信息
  checkinRecords(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/worker/checkin/month/records',
      method: 'get',
      params
    })
  },
  // 修改密码
  updatePassword(data) {
    return Axios({
      url:'/system/user/resetMobilePwd',
      method: 'post',
      data: data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/worker/index.js